import { EMOJI_PICKER_TRIGGER_CHARACTER } from '../constants';
import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function emojiPickerPluginTrigger(evt: PluginEvent, editor: Editor) {
    if (evt.eventType === PluginEventType.KeyPress) {
        let keyboardEvent = evt.rawEvent as KeyboardEvent;
        return keyboardEvent.key == EMOJI_PICKER_TRIGGER_CHARACTER;
    }
    return false;
}
